import React, { FC } from "react";
import { DateTime } from "luxon";
import Linkify from "react-linkify";

interface ProfileDescriptionProps {
  description?: string | undefined;
  joined?: number | undefined; //unix seconds
}

const ProfileDescription: FC<ProfileDescriptionProps> = ({
  description = undefined,
  joined = undefined,
}) => (
  <div
    className='flex flex-col space-y-24 text-dark-white-64 body1'
    style={{ wordBreak: "normal", overflowWrap: "anywhere" }}
  >
    {description && (
      <Linkify
        componentDecorator={(decoratedHref, decoratedText, key) => (
          <a
            target='blank'
            href={decoratedHref}
            key={key}
            className='hover:text-dark-red'
          >
            {decoratedText}
          </a>
        )}
      >
        <p className='whitespace-pre-wrap'>{description}</p>
      </Linkify>
    )}
    {joined && (
      <p>Joined {DateTime.fromSeconds(joined).toFormat("MMM yyyy")}</p>
    )}
  </div>
);

export default ProfileDescription;
